<template lang="html">
<section id="expertise" class="padded" v-if="isLandingMounted" :class="loaded ? 'loaded':''">
	<transition name="slide-fade">
		<div class="content flex">
			<div class="section-subtitle" v-html="home[currentLang].expertiseDescription"></div>
			<div class="content content--card">
				<section :id="'expertise'+index" 
					:class="toggleClasses('dropdown dropdown--light', 'expertise'+index)" 
					v-for="(expertiseSection, index) in home[currentLang].expertiseSections" 
					:key="'expertise'+index">
					<header class="dropdown-header" @click="showToggle('expertise'+index);">
						<h1>{{ expertiseSection.label }}</h1>
						<span class="dropdown-button"></span>
					</header>
					<transition name="slide">
						<div class="dropdown-content" v-if="show.includes('expertise'+index)">
							<p>{{ expertiseSection.description }}</p>
						</div>
					</transition>
				</section>
			</div>
		</div>
	</transition>
</section>
</template>

<script>

import dropdownHandler  from '@/mixins/dropdownHandler.js'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	mixins: [dropdownHandler, loaderHandler],
	props: ['home', 'isLandingMounted', 'currentLang'],
	mounted(){
		//this.showToggle('expertise0');
		this.displayComponent(2000);
	}
}
</script>

<style lang="scss">
	#expertise{
		max-width: 1600px;
		margin: auto;
		.flex{
			> div{
				width:100%;
			}
			@media screen and (min-width:980px){
				> div{
					width: calc(50% - 20px);
				}
			}
			.section-subtitle{
				margin: auto;
				padding: 0;
				p{
					max-width:420px;
				}
				@media screen and (max-width:768px){
					text-align:center;
				}
			}
			.content--card{
				@media screen and (max-width:768px){
					padding: 2rem;
					margin: 60px -30px 60px -30px;
				}
				margin: 73px 0 73px 20px;
				padding: 40px 55px;
			}
		}
	}


</style>
